'use strict';

angular.module('user')
    .service('AccountManager', ['$q', '$cookies', 'ShareCrfSDK', 'Event', function($q, $cookies, ShareCrfSDK, Event) {
        var initPromise = null;
        var loadPromise = null;

        var serviceData = {
            loginInfo: {
                lastLoginDate: null,
            },
            loggedUser: {
                id: null,
                anonymous: true,
                permissions: [],
                studyPermissions: [],
            },
        };

        var AccountManager = {};

        AccountManager.isSessionOpen = function() {
            return !!$cookies.getObject('session_settings');
        };

        AccountManager.init = function() {
            var promise;

            if (initPromise) {
                promise = initPromise;
            }
            else {
                if (AccountManager.isSessionOpen()) {
                    initPromise = AccountManager.reload();
                } else {
                    initPromise = $q.resolve();
                }

                initPromise = initPromise
                    .then(function() {
                        Event.trigger('accountInitied');
                    });

                promise = initPromise;
            }

            return promise;
        };

        // Logged user data ////////////////////////////////////////////////////////////////////////////////////////////

        /**
         * Init
         *
         * @return {Promise} -
         */
        AccountManager.reload = function() {
            var promise;

            if (loadPromise) {
                promise = loadPromise;
            }
            else {
                loadPromise = ShareCrfSDK.portal.getLoggedUser()
                    .then(function(userData) {
                        AccountManager.setLoggedUser(userData);

                        loadPromise = null;
                    });

                promise = loadPromise;
            }

            return promise;
        };

        /**
         * Set logged user
         *
         * @param {Object} userData New user data
         *
         * @private
         */
        AccountManager.setLoggedUser = function(userData) {
            var clearObject = {};
            for (var property in serviceData.loggedUser) {
                clearObject[property] = null;
            }
            _.merge(serviceData.loggedUser, clearObject, userData);
        };

        AccountManager.setLoginInfo = function(loginInfo) {
            var clearObject = {};
            for (var property in serviceData.loginInfo) {
                clearObject[property] = null;
            }
            _.merge(serviceData.loginInfo, clearObject, loginInfo);
        };

        /**
         * Get logged user
         *
         * @return {Object} User data
         */
        AccountManager.getLoggedUser = function() {
            return serviceData.loggedUser;
        };

        /**
         * Get loggin info
         *
         * @return {Object} Login info
         */
        AccountManager.getLoginInfo = function() {
            return serviceData.loginInfo;
        };

        /**
         * Is logged
         *
         * Returns if current user is logged or not.
         * Synchronous
         *
         * @return {Boolean} TRUE if logged
         */
        AccountManager.isLogged = function() {
            return !!(AccountManager.getLoggedUser().id);
        };

        // Permissions management //////////////////////////////////////////////////////////////////////////////////////

        /**
         * Has permission
         *
         * Returns if current user has given permission or not
         * Synchronous
         *
         * @param {String} permission Permission
         *
         * @return {Boolean} TRUE if user has given permission
         */
        AccountManager.hasPermission = function(permission) {
            var permissions = AccountManager.getLoggedUser().permissions || [];

            return permissions.indexOf(permission) !== -1;
        };

        /**
         * Has permission in study
         *
         * Returns if current user has given permission or not
         * Synchronous
         *
         * @param {String} studySubdomain Study subdomain
         * @param {String} permission     Permission
         *
         * @return {Boolean} TRUE if user has given permission
         */
        AccountManager.hasStudyPermission = function(studySubdomain, permission) {
            var permissions = AccountManager.getLoggedUser().studyPermissions[studySubdomain] || [];

            return permissions.indexOf(permission) !== -1;
        };

        // Session management //////////////////////////////////////////////////////////////////////////////////////////

        /**
         * Log in
         *
         * Makes a POST call to server with user credentials
         *
         * @param {String} email     User email
         * @param {String} password  Password
         *
         * @return {Promise} -
         */
        AccountManager.login = function(email, password) {
            Event.trigger('beforeLogin');

            return ShareCrfSDK.portal.login(email, password)
                .then(function(response) {
                    AccountManager.setLoginInfo(response);

                    return AccountManager.reload();
                })
                .finally(function() {
                    Event.trigger('login');
                });
        };

        /**
         * Register
         *
         * @param {Object} userData User data
         *
         * @return {Promise<Object>} Created user
         */
        AccountManager.register = function(userData) {
            return ShareCrfSDK.portal.signup(userData)
                .then(function(response) {
                    // Trigger event
                    Event.trigger('signUp', response);

                    return response;
                });
        };

        /**
         * Log out
         *
         * @return {Promise} -
         */
        AccountManager.logout = function() {
            return ShareCrfSDK.portal.logout()
                .then(function() {
                    // Set anonymous user
                    AccountManager.setLoggedUser({
                        id: null,
                        anonymous: true,
                        permissions: [],
                        studyPermissions: [],
                    });
                    AccountManager.setLoginInfo({});

                    // Trigger event
                    Event.trigger('logout');
                });
        };

        /**
         * Reload session
         *
         * @return {Promise} -
         */
        AccountManager.reloadSession = function() {
            return ShareCrfSDK.portal.session()
                .then(function() {
                    // Trigger event
                    Event.trigger('session');
                });
        };

        AccountManager.recoverPasswordRequest = function(email) {
            return ShareCrfSDK.portal.recoverPasswordRequest(email);
        }

        AccountManager.changePassword = function(data) {
            return ShareCrfSDK.portal.changePassword(data);
        }

        // AccountManager.allowPasswordChange
        AccountManager.validate = function(userId, validationHash) {
            return ShareCrfSDK.portal.validateUser(userId, validationHash)
        };

        // Profile data management /////////////////////////////////////////////////////////////////////////////////////

        /**
         * Update profile
         *
         * @param  {Object} data User data
         *
         * @return {Promise}     -
         */
        AccountManager.updateProfile = function(data) {
            return ShareCrfSDK.portal.profile.update(data)
                .then(function(userData) {
                    return AccountManager.setLoggedUser(userData);
                });
        };

        AccountManager.updatePassword = function(currentPassword, newPassword) {
            return ShareCrfSDK.portal.profile.updatePassword(currentPassword, newPassword);
        };

        // Reload user when a study is created
        Event.on('studyCreated', AccountManager.reload);
        Event.on('invitationAccepted', AccountManager.reload);

        return AccountManager;
    }]);
